<template>
    <div :style="{ height: progressHeight + 'px' }" class="progress-container">
        <div class="progress-bar" ref="progressBar"></div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        isStart: {
            type: Boolean,
            default: false
        },
        hideProgressBar: {
            type: Function,
            default: () => { }
        },
        progressHeight: {
            type: Number,
            default: 12
        }
    },
    methods: {
        startProgress() {
            this.$nextTick(() => {
                const progressBar = this.$refs.progressBar;
                if (!progressBar) return;
                // 초기화
                progressBar.style.transition = 'none';
                progressBar.style.transform = 'scaleX(0)';

                // 첫 번째 구간 (0% -> 50%)
                progressBar.style.transition = 'transform 4s ease-out';
                progressBar.style.transform = 'scaleX(0.35)';

                setTimeout(() => {
                    progressBar.style.transition = 'none';

                    setTimeout(() => {
                        progressBar.style.transition = 'transform 1s ease-out';
                        progressBar.style.transform = 'scaleX(1)';
                        setTimeout(() => {
                            this.hideProgressBar()
                            progressBar.style.transition = 'none'
                            progressBar.style.transform = 'scaleX(0)'
                        }, 1000)
                    }, 500);
                }, 4000);
            })
        },
    },
    watch: {
        isStart(newVal) {
            if (newVal) {
                this.startProgress()
            }
        }
    }
}
</script>

<style scoped>
.progress-container {
    width: 100%;
    background-color: #ddd;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
}

.progress-bar {
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #FF7111 0%, #FFD7BC 100%);
    transform: scaleX(0);
    border-radius: 12px;
    transform-origin: left;
    transition: transform 0s;
}
</style>